import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/bot-icon.png'
import _imports_1 from '../assets/super-app-ios.png'
import _imports_2 from '../assets/person-with-phone.png'
import _imports_3 from '../assets/super-app-android.png'
import _imports_4 from '../assets/app-screen.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f6e62cf8")

_pushScopeId("data-v-f6e62cf8")
const _hoisted_1 = { class: "container-size" }
const _hoisted_2 = { class: "w-full pb-4" }
const _hoisted_3 = { class: "bg-mingaku h-fit flex flex-col-reverse items-center gap-2 mb-4 py-2 sm:flex-row sm:justify-between sm:px-4 md:px-12" }
const _hoisted_4 = {
  ref: "textContainer",
  class: "textContainer w-52 h-14 bg-white rounded-lg border-black border-2 relative flex justify-center items-start text-2xl font-bold pt-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "absolute right-1 bottom-0 font-normal text-sm" }, "さん", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-cente" }, [
  /*#__PURE__*/_createVNode("h1", { class: "page-title text-4xl font-bold text-center sm:text-3xl md:text-4xl" }, " ログイン情報 "),
  /*#__PURE__*/_createVNode("p", { class: "font-bold mt-2 text-center" }, " ※この用紙は大切に保管しておきましょう ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-20 relative" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo",
    class: "w-full"
  }),
  /*#__PURE__*/_createVNode("p", { class: "absolute text-xs font-bold bottom-0 left-4" }, "みんがく")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-center mb-4 sm:flex-row sm:justify-center sm:gap-4" }, [
    /*#__PURE__*/_createVNode("h2", { class: "text-xl font-bold text-center sm:text-3xl" }, " ▼ みんがく公式アプリ "),
    /*#__PURE__*/_createVNode("p", { class: "text-base text-center sm:text-lg" }, " QRコードからアプリをダウンロードしよう！ ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-center gap-4 sm:flex-row sm:justify-around" }, [
    /*#__PURE__*/_createVNode("div", { class: "w-72 sm-w-fit" }, [
      /*#__PURE__*/_createVNode("p", { class: "relative bg-mingaku w-32 rounded-full text-lg font-bold text-center -left-1 mb-2" }, " iOS "),
      /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-end justify-center gap-2 w-fit" }, [
        /*#__PURE__*/_createVNode("div", { class: "bg-white p-1 w-fit" }, [
          /*#__PURE__*/_createVNode("div", { class: "w-28" }, [
            /*#__PURE__*/_createVNode("img", {
              class: "w-full",
              src: _imports_1,
              alt: "super-app-ios"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", null, [
          /*#__PURE__*/_createVNode("a", {
            href: "https://apps.apple.com/jp/app/%E3%81%BF%E3%82%93%E3%81%8C%E3%81%8F/id6469667602?itsct=apps_box_badge&itscg=30200",
            target: "_blank",
            class: "inline-block w-36 overflow-hidden"
          }, [
            /*#__PURE__*/_createVNode("img", {
              src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-jp?size=250x83&releaseDate=1699920000",
              alt: "Download on the App Store",
              class: "w-full h-full rounded-xl"
            })
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "phone-user hidden md:block" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_2,
        alt: "man-using-smart-phone"
      })
    ]),
    /*#__PURE__*/_createVNode("div", { class: "w-72 sm-w-fit" }, [
      /*#__PURE__*/_createVNode("p", { class: "relative bg-mingaku w-32 rounded-full text-lg font-bold text-center -left-1 mb-2" }, " Android "),
      /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-end justify-center gap-2 w-fit" }, [
        /*#__PURE__*/_createVNode("div", { class: "bg-white p-1 w-fit" }, [
          /*#__PURE__*/_createVNode("div", { class: "w-28" }, [
            /*#__PURE__*/_createVNode("img", {
              class: "w-full",
              src: _imports_3,
              alt: "super-app-ios"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", null, [
          /*#__PURE__*/_createVNode("a", {
            href: "https://play.google.com/store/apps/details?id=com.mingaku.mingakuapp&pcampaignid=web_share&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
            target: "_blank",
            class: "inline-block w-36 overflow-hidden"
          }, [
            /*#__PURE__*/_createVNode("img", {
              alt: "Google Play で手に入れよう",
              src: "https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png",
              class: "w-full h-full relative top-1"
            })
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_9 = { class: "w-full pt-8" }
const _hoisted_10 = { class: "relative w-10/12 flex flex-col items-center gap-2 pt-8 pb-4 px-4 mx-auto border-2 bg-white border-black mb-4 sm:hidden" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "login-info-ttl-pstn bg-mingaku font-bold text-xl px-4 py-1 rounded-lg" }, " みんがくログイン情報 ", -1)
const _hoisted_12 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "スクールID", -1)
const _hoisted_14 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_15 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "生徒ID", -1)
const _hoisted_17 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_18 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "パスワード", -1)
const _hoisted_20 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_21 = { class: "flex flex-col sm:flex-row sm:justify-between" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "custom-height w-fit mx-auto" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "h-full",
      src: _imports_4,
      alt: "app-screen"
    })
  ])
], -1)
const _hoisted_23 = { class: "grow" }
const _hoisted_24 = { class: "hidden relative w-11/12 sm:flex flex-col items-center gap-2 pt-8 pb-4 px-4 mx-auto border-2 bg-white border-black mb-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h3", { class: "login-info-ttl-pstn bg-mingaku font-bold text-xl px-4 py-1 rounded-lg" }, " みんがくログイン情報 ", -1)
const _hoisted_26 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "スクールID", -1)
const _hoisted_28 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_29 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "生徒ID", -1)
const _hoisted_31 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_32 = { class: "flex flex-row justify-center gap-2 w-full" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "w-3/12 text-center font-bold text-xl" }, "パスワード", -1)
const _hoisted_34 = { class: "w-8/12 text-xl border-2 border-black pl-1 flex flex-row items-center break-all" }
const _hoisted_35 = { class: "flex flex-col gap-2 py-2" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h2", { class: "custom-text text-2xl font-bold text-center text-coral-red px-2 break-all sm:text-left sm:pl-4" }, " A: 生徒ログイン用QRコード ", -1)
const _hoisted_37 = { class: "h-40 flex flex-row items-center justify-around mt-6 mb-2 px-2 sm:px-0" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "login-direction z-0 relative h-fit w-6/12 text-lg font-bold text-center text-coral-red md:text-2xl" }, [
  /*#__PURE__*/_createTextVNode(" A/B どちらかで"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("ログインできます ")
], -1)
const _hoisted_39 = { class: "bg-white p-1 w-fit" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h2", { class: "custom-text text-2xl font-bold text-center text-coral-red px-2 break-all sm:text-left sm:pl-4" }, " B: 生徒IDでログインする ", -1)
const _hoisted_41 = { class: "footer bg-mingaku w-full flex flex-col gap-4 pt-4 sm:flex-row sm:justify-between sm:px-4" }
const _hoisted_42 = { class: "flex flex-col items-center sm:w-4/12" }
const _hoisted_43 = /*#__PURE__*/_createVNode("h2", { class: "text-xl font-bold text-center mb-2" }, " ▼ アプリ利用方法 ", -1)
const _hoisted_44 = { class: "flex flex-row justify-center items-center mb-2 sm:justify-start" }
const _hoisted_45 = { class: "bg-white p-1 w-fit" }
const _hoisted_46 = { class: "font-bold text-center mb-2 underline break-all" }
const _hoisted_47 = { class: "flex flex-col items-center sm:w-4/12" }
const _hoisted_48 = /*#__PURE__*/_createVNode("h2", { class: "text-xl font-bold text-center mb-2" }, " ▼ 学習室の利用方法 ", -1)
const _hoisted_49 = { class: "flex flex-row justify-center items-center mb-2 sm:justify-start" }
const _hoisted_50 = { class: "bg-white p-1 w-fit" }
const _hoisted_51 = { class: "font-bold text-center mb-2 underline break-all" }
const _hoisted_52 = { class: "flex flex-col items-center sm:w-4/12" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h2", { class: "text-xl font-bold text-center mb-2" }, " ▼ みんがく公式ガイド ", -1)
const _hoisted_54 = { class: "flex flex-row justify-center items-center mb-2 sm:justify-start" }
const _hoisted_55 = { class: "bg-white p-1 w-fit" }
const _hoisted_56 = { class: "font-bold text-center mb-2 underline break-all" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MPrintInvitaion = _resolveComponent("MPrintInvitaion")
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MPrintInvitaion, {
      "clipboard-status-type": _ctx.clipboardStatusType,
      "clipboard-message": _ctx.clipboardMessage,
      "is-start-learning-btn-shown": false,
      onPrint: _ctx.print,
      onMessageCopy: _ctx.messageCopy
    }, null, 8, ["clipboard-status-type", "clipboard-message", "onPrint", "onMessageCopy"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datas, (data) => {
      return (_openBlock(), _createBlock("div", {
        key: data.studentName,
        class: "sheet flex flex-col items-center justify-between"
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("header", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(data.studentName) + " ", 1),
                _hoisted_5
              ], 512),
              _hoisted_6,
              _hoisted_7
            ]),
            _hoisted_8
          ]),
          _createVNode("main", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, _toDisplayString(data.schoolId), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, _toDisplayString(data.loginId), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, _toDisplayString(data.password), 1)
              ])
            ]),
            _createVNode("section", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("div", _hoisted_28, _toDisplayString(data.schoolId), 1)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, _toDisplayString(data.loginId), 1)
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, _toDisplayString(data.password), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("div", _hoisted_39, [
                      _createVNode(_component_qrcode_vue, {
                        class: "h-48 mx-auto",
                        value: data.code,
                        size: "180",
                        level: "H"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _hoisted_40
                ])
              ])
            ])
          ]),
          _createVNode("footer", _hoisted_41, [
            _createVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode("div", _hoisted_44, [
                _createVNode("div", _hoisted_45, [
                  _createVNode(_component_qrcode_vue, {
                    class: "h-48 mx-auto",
                    value: _ctx.MINGAKU_APP_GUIDE,
                    size: "96",
                    level: "H"
                  }, null, 8, ["value"])
                ])
              ]),
              _createVNode("a", {
                href: _ctx.MINGAKU_APP_GUIDE,
                target: "_blank"
              }, [
                _createVNode("p", _hoisted_46, _toDisplayString(_ctx.MINGAKU_APP_GUIDE), 1)
              ], 8, ["href"])
            ]),
            _createVNode("div", _hoisted_47, [
              _hoisted_48,
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode(_component_qrcode_vue, {
                    class: "h-48 mx-auto",
                    value: _ctx.MINGAKU_ROOMS_GUIDE,
                    size: "96",
                    level: "H"
                  }, null, 8, ["value"])
                ])
              ]),
              _createVNode("a", {
                href: _ctx.MINGAKU_ROOMS_GUIDE,
                target: "_blank"
              }, [
                _createVNode("p", _hoisted_51, _toDisplayString(_ctx.MINGAKU_ROOMS_GUIDE), 1)
              ], 8, ["href"])
            ]),
            _createVNode("div", _hoisted_52, [
              _hoisted_53,
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _createVNode(_component_qrcode_vue, {
                    class: "h-48 mx-auto",
                    value: _ctx.MINGAKU_GUIDE,
                    size: "96",
                    level: "H"
                  }, null, 8, ["value"])
                ])
              ]),
              _createVNode("a", {
                href: _ctx.MINGAKU_GUIDE,
                target: "_blank"
              }, [
                _createVNode("p", _hoisted_56, _toDisplayString(_ctx.MINGAKU_GUIDE), 1)
              ], 8, ["href"])
            ])
          ])
        ])
      ]))
    }), 128))
  ], 64))
})